import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc5b342a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "undelegate"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-unlock" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "undelegate"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-unlock" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "component-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (!_ctx.wrapUsingRow)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.ready)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["component-wrap", { 'mb-3': !_ctx.inRow && _ctx.field.type !== 'group' }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["component", { delegated: _ctx.isDelegated }]),
                onContextmenu: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rightClick && _ctx.rightClick(...args)), ["right","prevent","stop"])),
                onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('helptext', _ctx.field.helpText))),
                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('helptext', null)))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.fieldComponent), {
                  field: _ctx.field,
                  object: _ctx.object,
                  "in-row": _ctx.inRow,
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
                  onInput: _ctx.fieldChanged,
                  onDependencyChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dependency-change', $event))),
                  onCustomAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('custom-action', $event)))
                }, null, 40, ["field", "object", "in-row", "modelValue", "onInput"]))
              ], 34),
              (_ctx.isDelegatable)
                ? (_openBlock(), _createBlock(_component_context_menu, {
                    key: 0,
                    onContextMenuItemClick: _ctx.contextMenuItemClick,
                    show: _ctx.contextMenu.show,
                    position: _ctx.contextMenu.position,
                    context: _ctx.contextMenu.context,
                    element: _ctx.contextMenu.element,
                    menus: _ctx.contextMenu.menus
                  }, null, 8, ["onContextMenuItemClick", "show", "position", "context", "element", "menus"]))
                : _createCommentVNode("", true),
              (_ctx.isDelegated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-dark",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleDelegated && _ctx.toggleDelegated(...args)))
                    }, _hoisted_3)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Spinner)
            ]))
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.ready)
          ? (_openBlock(), _createElementBlock("tr", {
              key: 0,
              class: _normalizeClass({ delegated: _ctx.isDelegated }),
              onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('helptext', _ctx.field.helpText))),
              onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('helptext', null)))
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.fieldComponent), {
                field: _ctx.field,
                object: _ctx.object,
                "in-row": _ctx.inRow,
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value) = $event)),
                onContextmenu: _withModifiers(_ctx.rightClick, ["right","prevent","stop"]),
                onInput: _ctx.fieldChanged,
                onDependencyChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('dependency-change', $event))),
                onCustomAction: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('custom-action', $event)))
              }, null, 40, ["field", "object", "in-row", "modelValue", "onContextmenu", "onInput"])),
              (_ctx.isDelegatable)
                ? (_openBlock(), _createBlock(_component_context_menu, {
                    key: 0,
                    onContextMenuItemClick: _ctx.contextMenuItemClick,
                    show: _ctx.contextMenu.show,
                    position: _ctx.contextMenu.position,
                    context: _ctx.contextMenu.context,
                    element: _ctx.contextMenu.element,
                    menus: _ctx.contextMenu.menus
                  }, null, 8, ["onContextMenuItemClick", "show", "position", "context", "element", "menus"]))
                : _createCommentVNode("", true),
              (_ctx.isDelegated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-dark",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleDelegated && _ctx.toggleDelegated(...args)))
                    }, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_8, [
                _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
              ])
            ], 34))
          : _createCommentVNode("", true)
      ], 64))
}